export const BASE_API = "https://staging.onramper.tech";
